var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 0C4.08 0 3.012 1.08 3.012 2.4L3 21.6C3 22.92 4.068 24 5.388 24H19.8C21.12 24 22.2 22.92 22.2 21.6V8.196C22.2 7.56 21.948 6.948 21.492 6.504L15.696 0.708C15.252 0.252 14.64 0 14.004 0H5.4Z",
    fill: "#7E7E7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5636 9.98086V15.9818C14.5636 17.1672 13.629 18.2222 12.3583 18.3356C10.8982 18.4661 9.67637 17.4054 9.67637 16.0782V9.06768C9.67637 8.32466 10.2506 7.6497 11.0448 7.57596C11.9612 7.49088 12.7309 8.1545 12.7309 8.98827V14.9438C12.7309 15.2558 12.456 15.511 12.12 15.511C11.784 15.511 11.5091 15.2558 11.5091 14.9438V9.98086C11.5091 9.74831 11.3014 9.55546 11.0509 9.55546C10.8004 9.55546 10.5927 9.74831 10.5927 9.98086V14.8644C10.5927 15.6074 11.167 16.2824 11.9612 16.3561C12.8775 16.4412 13.6473 15.7776 13.6473 14.9438V9.08469C13.6473 7.89926 12.7126 6.84428 11.4419 6.73084C9.98794 6.60039 8.76001 7.66104 8.76001 8.98827V15.9477C8.76001 17.5756 10.0429 19.0333 11.7901 19.1864C13.8 19.3566 15.48 17.9045 15.48 16.0782V9.98086C15.48 9.74831 15.2723 9.55546 15.0218 9.55546C14.7714 9.55546 14.5636 9.74831 14.5636 9.98086Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.0eab60aa.svg";
export { ForwardRef as ReactComponent };